<template>
  <div class="max-w-1080px mx-auto my-10 md:my-20">
    <div class="flex items-center gap-1 text-5 font-semibold">
      <Logo size="30" color="currentColor" />
      <span>Orie</span>
    </div>

    <PageHeading
      class="mt-4"
      title="Orie Plan: "
      :return-to="{ name: 'access-pricing' }"
      :subtitle="planDescription"
      outset-nav
    >
      <template #append-title>
        <span class="opacity-70 ml-2">{{ planTitle }}</span>
      </template>
    </PageHeading>

    <ConfirmPlanPage class="mt-10" :handle="handle" :pk="pk" />
  </div>
</template>

<script lang="ts">
import ConfirmPlanPage from "~/components/pages/plan-subscription/confirm/ConfirmPlanPage.vue";
import { useConfirmPlanStore } from "~/components/pages/plan-subscription/confirm/store";
import { PublicPlatformPlanPeriod } from "~/layers/ui/models/Plan";

export default defineComponent({
  components: {
    ConfirmPlanPage,
  },
  setup() {
    definePageMeta({
      layout: "blank",
      middleware: "select-plan",
    });

    const config = useRuntimeConfig();
    const route = useRoute();
    const store = useConfirmPlanStore();
    const { planTitle, hasNoPaymentItems, plan } = storeToRefs(store);

    const handle = String(route.params.plan);
    const planDescription = computed(() => plan.value.description);

    onMounted(() => {
      if (route.query.period) {
        const period = match(String(route.query.period), {
          [PublicPlatformPlanPeriod.Monthly]: 1,
          [PublicPlatformPlanPeriod.Yearly]: 12,
        });

        if (period) {
          store.selected = period;
        }
      }
    });

    return {
      pk: config.public.stripe.pk,
      handle,
      planTitle,
      hasNoPaymentItems,
      planDescription,
    };
  },
});
</script>

